module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDE0IDExIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBhdGggZD0iTTYwLjM0MSA1OTRMNjIuMiA1OTUuMjgxIDU0LjY1NyA2MDUgNDkgNjAxLjAxNSA1MC4zNzkgNTk5LjI3NyA1NC4xNzIgNjAxLjk0OXoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00OSAtNTk0KSIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/onboarding/icons/icon-small-check.svg
// module id = r2a7
// module chunks = 6